import { createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
  name: "options",
  initialState: {
    propertyType: "not Selected",
    price: "not Selected",
    area: "not Selected",
    city: "not Selected",
    features: "not Selected",
    status: "idle",
    keywords: "not Selected",
    subType: "not Selected",
    error: null,
  },
  reducers: {
    // Define reducers if needed
    setPropertyTypeOptions: (state, action) => {
      state.propertyType = action.payload;
    },
    setPriceOptions: (state, action) => {
      state.price = action.payload;
    },
    setAreaOptions: (state, action) => {
      state.area = action.payload;
    },
    setCityOptions: (state, action) => {
      state.city = action.payload;
    },
    setFeaturesOptions: (state, action) => {
      state.features = action.payload;
    },
    setKeywordsOptions: (state, action) => {
      state.keywords = action.payload;
    },
    setSubTypeOptions: (state, action) => {
      state.subType = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle async actions if needed
  },
});

export const {
  setPropertyTypeOptions,
  setPriceOptions,
  setAreaOptions,
  setCityOptions,
  setFeaturesOptions,
  setKeywordsOptions,
  setSubTypeOptions,
} = optionsSlice.actions;

export default optionsSlice.reducer;
